import React from 'react';
import { ImageRenderer as ImageRendererV1 } from './imageRenderer';
import { ImageRenderer as ImageRendererV2 } from './imageRendererV2';
import { fg } from '@atlaskit/platform-feature-flags';
export var ImageRenderer = function ImageRenderer(props) {
  return fg('platform_media_card_image_render') ? /*#__PURE__*/React.createElement(ImageRendererV2, props) : /*#__PURE__*/React.createElement(ImageRendererV1, props);
};